module.exports = __webpack_public_path__ + "img/living.88e31e7b.png";